import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5156bd9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-3 flex flex-col gap-5 pb-14" }
const _hoisted_2 = {
  id: "scroll",
  class: "flex overflow-x-scroll flex-nowrap gap-5"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-white" }, "Top contributor", -1))
const _hoisted_5 = { class: "w-full flex justify-center gap-3 my-3" }
const _hoisted_6 = { class: "flex flex-col w-fit mt-5 gap-1" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-white text-center" }, "Tanya", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-2 py-2 bg-wizard-education w-fit rounded-full font-bold text-white" }, "111 points", -1))
const _hoisted_11 = { class: "flex flex-col w-fit gap-1" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-white text-center" }, "Ben", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-2 py-2 bg-wizard-education w-fit rounded-full font-bold text-white mt-2" }, "125 points", -1))
const _hoisted_16 = { class: "flex flex-col w-fit mt-5 gap-1" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-white text-center" }, "Samantha", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-2 py-2 bg-wizard-education w-fit rounded-full font-bold text-white" }, "95 points", -1))
const _hoisted_21 = { class: "font-bold text-xl text-left" }
const _hoisted_22 = { class: "font-normal text-base" }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "m-auto my-10 px-5 w-full text-center text-gray-100 font-bold" }

import { ref, computed, watch, onMounted } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { useNewsFeedStore } from "@/store/newsfeed"
  import { useRoute } from "vue-router"
  import { record } from "@/utils/analytics"
  import { ellipsisHorizontal } from "ionicons/icons"
  import { IonList, modalController } from "@ionic/vue"
  import { filter } from "lodash"
  import router from "@/router"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import BottomModal from "@/components/template/BottomModal.vue"
  import ThoughtLeadershipContainer from "@/components/workbean-page/home/ThoughtLeadership.vue"
  import EmployeeAmbassadorshipContainer from "@/components/workbean-page/home/EmployeeAmbassadorship.vue"
  import PostTemplate from "@/components/template/PostTemplate.vue"
  import ModalContainer from "@/components/workbean-page/ModalContainer.vue"
  import Insights from "@/components/world-feed/InsightContainer.vue"

  // image
  import ContributorBackground from "@/assets/images/discover/home/top-contributor.png"
  import ContributorImage from "@/assets/images/discover/home/contributor-image.png"
  import FirstAward from "@/assets/images/discover/home/first.svg"
  import SecondAward from "@/assets/images/discover/home/second.svg"
  import ThirdAward from "@/assets/images/discover/home/third.svg"
  import PeopleImage from "@/assets/images/discover/people-image.png"
  import UserImage from "@/assets/images/user-icon.svg"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

  const store = useCompanyStore()
  const newsfeedStore = useNewsFeedStore()

  const route = useRoute()
  const companyDetails = computed(() => store.companyDetails)
  const feedList = computed(() => filter(newsfeedStore.newsfeedList, "answer_content"))
  const jobCount = computed(() => store.allJobs.length)
  const hash = ref("")
  const activeTab = ref("all")
  const option = ["all", "thought leadership", "employee ambassadorship"]
  const emptyOption = (option: string) => {
    switch (option) {
      case "thought leadership":
        return " thought leadership"
      case "employee ambassadorship":
        return " employee ambassadorship"
      default:
        return ""
    }
  }
  const categorizedList = computed(() => {
    const obj = {
      all: [],
      thought_leadership: [],
      employee_ambassadorship: [],
    } as any
    if (hash.value !== "") {
      obj.all = filter(feedList.value, ["newsfeed_id", hash.value])
    } else obj.all = feedList.value
    obj.employee_ambassadorship = filter(feedList.value, (post) => {
      return post.answer_content?.answer?.answers?.length > 0
    })

    obj.thought_leadership = filter(feedList.value, (post) => {
      return post.answer_content?.answer?.answer?.length > 0
    })

    return obj
  })
  const activeCategorizedList = computed(() =>
    activeTab.value === "all"
      ? categorizedList.value.all
      : activeTab.value === "thought leadership"
      ? categorizedList.value.thought_leadership
      : activeTab.value === "employee ambassadorship"
      ? categorizedList.value.employee_ambassadorship
      : []
  )

  const gotoJob = () => router.push(`/company/${route.params.slug}/job`)

  onMounted(() => {
    if (router.currentRoute.value.hash) {
      hash.value = router.currentRoute.value.hash.slice(1)
    }

    record({
      event: "CompanyViewPage",
      attributes: {
        link: route.fullPath,
        company_id: store.companyDetails.company_id,
      },
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(option, (options) => {
        return _createElementVNode("span", {
          key: `${options}_id`,
          class: "font-bold rounded-base bg-light-gray-100 px-5 py-3 capitalize flex flex-none",
          style: _normalizeStyle(
          activeTab.value === `${options}`
            ? {
                'font-weight': 700,
                color: '#fff',
                'background-color': _unref(companyDetails).brand_color || '#7442c8',
              }
            : { color: '#000000' }
        ),
          onClick: ($event: any) => (activeTab.value = options)
        }, _toDisplayString(options), 13, _hoisted_3)
      }), 64))
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bg-clip-border bg-cover bg-origin-border bg-no-repeat bg-center p-5 rounded-3xl",
          style: _normalizeStyle({ 'background-image': `url(${_unref(ContributorBackground)})` })
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "rounded-full px-2 py-2 bg-dark-gray h-[90px] w-[90px]",
                src: _unref(ContributorImage),
                alt: ""
              }, null, 8, _hoisted_7),
              _createElementVNode("img", {
                class: "ml-16 -mt-8 w-8 h-8",
                src: _unref(SecondAward),
                alt: ""
              }, null, 8, _hoisted_8),
              _hoisted_9,
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                class: "rounded-full px-2 py-2 bg-dark-yellow h-[100px] w-[100px]",
                src: _unref(ContributorImage),
                alt: ""
              }, null, 8, _hoisted_12),
              _createElementVNode("img", {
                class: "ml-16 -mt-7 w-8 h-8",
                src: _unref(FirstAward),
                alt: ""
              }, null, 8, _hoisted_13),
              _hoisted_14,
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", {
                class: "rounded-full px-2 py-2 bg-dark-red h-[90px] w-[90px]",
                src: _unref(ContributorImage),
                alt: ""
              }, null, 8, _hoisted_17),
              _createElementVNode("img", {
                class: "ml-16 -mt-8 w-8 h-8",
                src: _unref(ThirdAward),
                alt: ""
              }, null, 8, _hoisted_18),
              _hoisted_19,
              _hoisted_20
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_unref(jobCount) > 0)
      ? (_openBlock(), _createBlock(CardTemplate, {
          key: 1,
          class: "p-10 flex"
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "flex w-full gap-5 items-center",
              onClick: gotoJob
            }, [
              _createElementVNode("i", {
                class: "workbean-job text-3xl px-5 py-4 rounded-base",
                style: _normalizeStyle({ 'background-color': `${_unref(companyDetails).brand_color}50` || '#7442c850', color: _unref(companyDetails).brand_color || '#7442c8' })
              }, null, 4),
              _createElementVNode("span", _hoisted_21, [
                _createTextVNode("Apply now "),
                _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(jobCount)) + " job opening" + _toDisplayString(_unref(jobCount) > 1 ? "s" : ""), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonList), { lines: "none" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feedList), (feed, index) => {
          return (_openBlock(), _createBlock(PostTemplate, {
            key: `${index}_feed`,
            "post-data": feed,
            "post-page-location": "world"
          }, {
            default: _withCtx(() => [
              (!feed.answer_content && feed.content.html)
                ? (_openBlock(), _createBlock(Insights, {
                    key: 0,
                    id: feed.newsfeed_id,
                    "html-link": feed.content.html
                  }, null, 8, ["id", "html-link"]))
                : (feed.answer_content && feed.answer_content.answer && feed.answer_content.answer.answers && feed.answer_content.answer.answers.length > 0)
                  ? (_openBlock(), _createBlock(EmployeeAmbassadorshipContainer, {
                      key: 1,
                      "user-answers": feed.answer_content,
                      likes: feed.likes,
                      shares: feed.shares,
                      post_id: feed.newsfeed_id
                    }, null, 8, ["user-answers", "likes", "shares", "post_id"]))
                  : (feed.answer_content && feed.answer_content.answer && feed.answer_content.answer.answer)
                    ? (_openBlock(), _createBlock(ThoughtLeadershipContainer, {
                        key: 2,
                        "post-id": feed.newsfeed_id,
                        user: feed.answer_content.user,
                        answer: feed.answer_content.answer,
                        company: feed.answer_content.company
                      }, null, 8, ["post-id", "user", "answer", "company"]))
                    : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["post-data"]))
        }), 128))
      ]),
      _: 1
    }),
    (!_unref(activeCategorizedList).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("p", _hoisted_24, "No" + _toDisplayString(emptyOption(activeTab.value)) + " posts yet", 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})